import { useField } from '@adflow/frontend/util-common';

import type { FormControlProps } from '../FormControl';
import { FormControl } from '../FormControl';

import type { SelectorSelectProps } from './SelectorSelect';
import { SelectorSelect } from './SelectorSelect';

export interface SelectorSelectWithControlProps
	extends
		Omit<SelectorSelectProps, 'value' | 'onChange'>,
		Pick<
			FormControlProps,
			'outerStyle' | 'helperStyle' | 'error' | 'helperText'
		> {
	label?: string;
	name: string;
	onChangeEffect?: (value: string) => void;
}

export function SelectorSelectWithControl(
	props: SelectorSelectWithControlProps
) {
	const {
		label,
		name,
		defaultValue,
		outerStyle,
		helperStyle,
		error: extraError,
		helperText,
	} = props;

	const {
		field: { onChange, value, ref },
		fieldState: { invalid: error },
		errorMessage,
	} = useField({ name, label: props.label, defaultValue });

	return (
		<FormControl
			error={error ?? extraError}
			helperText={errorMessage ?? helperText}
			outerStyle={outerStyle}
			helperStyle={helperStyle}
			label={label}
		>
			<SelectorSelect
				inputRef={ref}
				value={value}
				onChange={(v) => {
					onChange(v);
					props.onChangeEffect?.(v);
				}}
				error={error}
				testid={name}
				{...props}
			/>
		</FormControl>
	);
}
